/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SettlementFooterComponent} from './settlement-footer.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [SettlementFooterComponent],
    exports: [SettlementFooterComponent]
})
export class SettlementFooterModule {
}
